import type { Auth } from "@/models/auth";

export const state: Auth = {
  token: "",
  sessionTimeout: "",
  login: "",
};
